import { render } from "./PageContentInfo.vue?vue&type=template&id=61137fbc&scoped=true"
import script from "./PageContentInfo.vue?vue&type=script&lang=js"
export * from "./PageContentInfo.vue?vue&type=script&lang=js"

import "./PageContentInfo.vue?vue&type=style&index=0&id=61137fbc&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61137fbc"]])

export default __exports__